import { createBrowserRouter, createRoutesFromElements, RouterProvider, Route, Navigate } from 'react-router-dom'
import { AuthProvider, useAuth } from './auth/AuthContext.js'
import LoginPage from './pages/LoginPage.js'
import ProjectsPage from './pages/ProjectsPage.js'
import ProjectPage from './pages/ProjectPage.js'
import EditorPage from './pages/EditorPage.js'
import BillingPage from './pages/BillingPage.js'
import { usePublicConfig } from './hooks/usePublicConfig.js'
import { ChangePasswordDialog } from './components/common/dialogs.js'

function Protected({ children }) {
  const { isLoggedIn, checkingSession, user, changePassword, logout } = useAuth()
  if (checkingSession) return null
  if (!isLoggedIn) return <Navigate to="/login" replace />
  if (user?.passwordChangeRequired) return <ChangePasswordDialog open required onChange={changePassword} onClose={logout} />
  return children
}

function Feature({ flag, children }) {
  const features = usePublicConfig()
  if (!features) return null
  return features[flag] ? children : <Navigate to="/" replace />
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/"
        element={
          <Protected>
            <ProjectsPage />
          </Protected>
        }
      />
      <Route
        path="/p/:id"
        element={
          <Protected>
            <ProjectPage />
          </Protected>
        }
      />
      <Route
        path="/p/:id/files/:fileId"
        element={
          <Protected>
            <EditorPage />
          </Protected>
        }
      />
      <Route
        path="/billing"
        element={
          <Protected>
            <Feature flag="billingEnabled">
              <BillingPage />
            </Feature>
          </Protected>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </>
  )
)

export default function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  )
}
